function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.457 38.02V0h1.086v38.02l2.53-2.699a.52.52 0 01.768 0 .608.608 0 010 .82l-3.457 3.69a.52.52 0 01-.768 0L.159 36.14a.608.608 0 010-.82.52.52 0 01.768 0l2.53 2.7z",
  fill: "#FFFBF5"
});

function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 40,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjQwIiB2aWV3Qm94PSIwIDAgOCA0MCIgZmlsbD0ibm9uZSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy40NTY4MSAzOC4wMjA3VjBINC41NDMxOVYzOC4wMjA3TDcuMDcyNzIgMzUuMzIxMUM3LjI4NDg1IDM1LjA5NDcgNy42Mjg3OCAzNS4wOTQ3IDcuODQwOSAzNS4zMjExQzguMDUzMDMgMzUuNTQ3NSA4LjA1MzAzIDM1LjkxNDYgNy44NDA5IDM2LjE0MUw0LjM4NDA5IDM5LjgzMDJDNC4xNzE5NiA0MC4wNTY2IDMuODI4MDQgNDAuMDU2NiAzLjYxNTkxIDM5LjgzMDJMMC4xNTkwOTUgMzYuMTQxQy0wLjA1MzAzMTggMzUuOTE0NiAtMC4wNTMwMzE4IDM1LjU0NzUgMC4xNTkwOTUgMzUuMzIxMUMwLjM3MTIyMyAzNS4wOTQ3IDAuNzE1MTQ5IDM1LjA5NDcgMC45MjcyNzYgMzUuMzIxMUwzLjQ1NjgxIDM4LjAyMDdaIiBmaWxsPSIjRkZGQkY1Ii8+Cjwvc3ZnPgo=";
export { SvgDownArrow as ReactComponent };